// import Vue from 'vue'
// import axios from 'axios'
// import VueAxios from 'vue-axios'
// Vue.use(axios)
// Vue.use(VueAxios)
import axios from '@/plugins/axios'

export default {
  install(Vue) {
    Vue.prototype.$sidelightApiService = {
      sidelight_api_url: `${process.env.VUE_APP_SIDELIGHT_API_URL}/sidelights`,

      /**
       * 查詢
       * @param {string} param - API 查詢參數
       * @returns {Promise<Object>} API 回傳的資料結構
       */
      async query(param = '') {
        const url = `${this.sidelight_api_url}`
        const params = param ? `?${param}` : ''
        const response = await axios.get(`${url}${params}`)
        return response.data
      },

      /**
       * 根據分類查詢
       * @param {string} category - 分類
       * @param {string} additional - 額外的 API 查詢參數
       * @returns {Promise<Object>} API 回傳的資料結構
       */
      async queryByCategory(category, additional = '') {
        const url = `${this.sidelight_api_url}?filter[category]=${category}`
        const additional_params = additional ? `&${additional}` : ''
        const response = await axios.get(`${url}${additional_params}`)
        return response.data
      },

      /**
       * 取得發生年份清單
       * @returns {Promise<Object>} API 回傳的資料結構
       */
      async getListOfOccurrenceYear() {
        const response = await axios.get(`${this.sidelight_api_url}/occurrence-year`)
        return response.data
      },

      /**
       * 根據相關資源查詢
       * @param {string} related_resource_type - 相關資源類型
       * @param {string} related_resource_code - 相關資源編碼
       * @param {string} additional - 額外的 API 查詢參數
       * @returns {Promise<Object>} API 回傳的資料結構
       */
      async getByRelatedResource(related_resource_type, related_resource_code, additional = '') {
        const url = `${this.sidelight_api_url}?filter[related_resource_type]=${related_resource_type}&filter[related_resource_code]=${related_resource_code}`
        const additional_params = additional ? `&${additional}` : ''
        const response = await axios.get(`${url}${additional_params}`)
        return response.data.data && response.data.data.length > 0
          ? response.data.data[0]
          : null
      },

      /**
       * 根據 ID 查詢
       * @param {string} id - ID
       * @param {string} additional - 額外的 API 查詢參數
       * @returns {Promise<Object>} API 回傳的資料結構
       */
      async getById(id, additional = '') {
        const url = `${this.sidelight_api_url}/${id}`
        const additional_params = additional ? `?${additional}` : ''
        const response = await axios.get(`${url}${additional_params}`)
        return response.data.data && Object.keys(response.data.data).length > 0
          ? response.data
          : null
      },

      /**
       * 取得照片
       * @param {string} id - ID
       * @param {string} additional - 額外的 API 查詢參數
       * @returns {Promise<Object>} API 回傳的資料結構
       */
      async fetchPhotos(id, additional = '') {
        const url = `${this.sidelight_api_url}/${id}/photos`
        const additional_params = additional ? `?${additional}` : ''
        const response = await axios.get(`${url}${additional_params}`)
        return response.data
      },

      /**
       * 取得影片
       * @param {string} id - ID
       * @param {string} additional - 額外的 API 查詢參數
       * @returns {Promise<Object>} API 回傳的資料結構
       */
      async fetchVideos(id, additional = '') {
        const url = `${this.sidelight_api_url}/${id}/videos`
        const additional_params = additional ? `?${additional}` : ''
        const response = await axios.get(`${url}${additional_params}`)
        return response.data
      },

      /**
       * 取得照片壓縮檔
       * @param {string} id - ID
       * @param {string} additional - 額外的 API 查詢參數
       * @returns {Promise<Object>} API 回傳的資料結構
       */
      async fetchPhotoCompressedFiles(id, additional = '') {
        const url = `${this.sidelight_api_url}/${id}/photo-compressed-files`
        const additional_params = additional ? `?${additional}` : ''
        const response = await axios.get(`${url}${additional_params}`)
        return response.data
      }
    }
  }
}
